import { render, staticRenderFns } from "./edit-publicity.vue?vue&type=template&id=37ed01b0&scoped=true"
import script from "./edit-publicity.vue?vue&type=script&lang=js"
export * from "./edit-publicity.vue?vue&type=script&lang=js"
import style0 from "./edit-publicity.vue?vue&type=style&index=0&id=37ed01b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed01b0",
  null
  
)

export default component.exports